import * as yup from "yup";

export const reelShortsSchema = yup.object().shape({
  shortTitle: yup.string(),
  shortBrandingAss: yup.string(),
  reelShortDate: yup.string(),
  shortScript: yup.string(),
  shortThumbnail: yup.string(),
  shortDescription: yup.string(),
  shortDriveLink: yup.string(),
  reelShortEditor: yup.string(),
  markAsPublished: yup.string(),
  reelType: yup.string(),
  reelFirstPath: yup.string(),
  publishDate: yup.string(),
  publishTime: yup.string(),
  rawSource: yup.string(),
  taskdedline: yup.string(),
});
